import React, { useCallback } from 'react';

import { ConstantFunctions } from '../../utils';
import Scrollbar from '../scrollbars';
import { Styled } from './styled';


export const ModalWrapper = (props) => {
  const { children, withScroll, onExit, zIndex } = props;

  const onClick = useCallback(e => e.currentTarget.firstChild === e.target && onExit());
  const onMouseDown = useCallback(e => e.currentTarget === e.target && onExit());

  return (
    <Styled.Container
      onMouseDown={onMouseDown}
      onMouseUp={ConstantFunctions.stopEvent}
      zIndex={zIndex}
    >
      {withScroll ? (
        <Scrollbar
          onClick={onClick}
        >
          {children}
        </Scrollbar>
      ) : (
        children
      )}
    </Styled.Container>
  )
}
